import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, PageState } from '../../components/ui';
import { useAuth } from '../../auth/AuthContext';
import { usePipelines } from '../../api/pipelines';

export function PipelinesPage() {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { data, isPending, isError, error, refetch } = usePipelines();
  const canManage = hasPermission('pipelines.manage');

  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
        <h1 style={{ margin: 0, fontSize: 'var(--font-size-xl)' }}>Pipelines</h1>
        <span style={{ flex: 1 }} />
        {canManage ? (
          <Button onClick={() => navigate('/pipelines/new')}>New pipeline</Button>
        ) : null}
      </div>

      {isPending ? (
        <PageState kind="loading" message="Loading pipelines…" />
      ) : isError ? (
        <PageState kind="error" message={error.message} onRetry={() => void refetch()} />
      ) : data.length === 0 ? (
        <PageState kind="empty" title="No pipelines" message="Create your first pipeline." />
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
          {data.map((p) => (
            <Card key={p.id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                <strong>{p.name}</strong>
                {p.isDefault ? <span className="ne-badge">default</span> : null}
                <span style={{ flex: 1 }} />
                {canManage ? (
                  <Button variant="secondary" onClick={() => navigate(`/pipelines/${p.id}/edit`)}>
                    Edit
                  </Button>
                ) : null}
              </div>
              {p.description ? (
                <p style={{ color: 'var(--color-text-muted)', margin: 'var(--space-2) 0 0' }}>
                  {p.description}
                </p>
              ) : null}
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 'var(--space-2)',
                  marginTop: 'var(--space-3)',
                }}
              >
                {p.stages.map((s) => (
                  <span key={s.id} className="ne-badge">
                    {s.name}
                    {s.isClosedWon ? ' ✓' : s.isClosedLost ? ' ✕' : ''}
                  </span>
                ))}
              </div>
            </Card>
          ))}
        </div>
      )}

      <p style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
        <Link to="/">← Back to dashboard</Link>
      </p>
    </div>
  );
}
